/* The constants in this file are canonical identifiers for use with `Telemetry` timer metric methods.
 *
 * All timer metric identifiers should be written in `kebab-case`.
 */

/****************************/
/*** Patient Summarization ***/
/**************************/

/* The time between when the user initiates a summary generation and we show them the summary complete toast
 */
export const TIMER_PATIENT_SUMMARY_GENERATION_DURATION_IN_SECONDS =
  'patient-summary-generation-duration-in-seconds' as const;
